import React, {Component}                               from "react";
import {ImageBackground, Platform, Switch, Text, View}  from "react-native";
import {connect}                                        from "react-redux";
import Button                                           from "../Button";
import * as Actions                                     from "../../constants/Actions";
import * as Screens                                     from "../../constants/Screens";
import styles                                           from "../../styles/Styles";

class ScreenSettings extends Component {
    takePhoto = (index) => {
        this.props.setPhotoIndex(index);
        this.props.changeScreen(Screens.CAMERA);
    }

    render() {
        var settingsMultiplayer = null;
        if (this.props.numPlayers > 1) {
            var showAnswers = 
                <View key={1} style={styles.viewSettingsRow}>
                    <Text style={styles.textSetting}>Show Answers</Text>
                    <Switch disabled={this.props.shareScreen} onValueChange={this.props.setShowAnswers} value={this.props.showAnswers} />
                </View>;

            var swipeControls = null;
            if (Platform.OS !== "web") {
                swipeControls = 
                    <View key={2} style={styles.viewSettingsRow}>
                        <Text style={styles.textSetting}>Use Swipe Controls</Text>
                        <Switch onValueChange={this.props.setSwipeControls} value={this.props.swipeControls} />
                    </View>;
            }

            var shareScreen = 
                <View key={3} style={styles.viewSettingsRow}>
                    <Text style={styles.textSetting}>Share Screen</Text>
                    <Switch onValueChange={this.props.setShareScreen} value={this.props.shareScreen} />
                </View>;

            settingsMultiplayer = [shareScreen, showAnswers, swipeControls];
        }

        return (
            <View style={styles.background}>
                <ImageBackground source={require("../../../assets/screen_settings.png")} style={styles.background} imageStyle={styles.backgroundImageScreen}>
                    <View style={styles.viewSettingsScreen}>
                        <Text style={styles.textTitle}>SETTINGS</Text>

                        <View style={styles.viewSettingsDisplay}>
                            <View style={styles.viewSettingsRow}>
                                <Text style={styles.textSetting}>Show Countdown</Text>
                                <Switch onValueChange={this.props.setEnableCountdown} value={this.props.enableCountdown} />
                            </View>
                            <View style={styles.viewSettingsRow}>
                                <Text style={styles.textSetting}>Play Sound Effects</Text>
                                <Switch onValueChange={this.props.setSoundEffects} value={this.props.soundEffects} />
                            </View>

                            {settingsMultiplayer}

                            <View style={styles.menuHorz}>
                                <Button onPress={() => {this.props.changeScreen(Screens.TITLE)}} text="Exit" />
                                <Button onPress={() => {this.props.changeScreen(Screens.SETTINGS_PLAYER)}} text="Next" />
                            </View>
                        </View>
                    </View>
                </ImageBackground>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        enableCountdown:    state.enableCountdown,
        numPlayers:         state.numPlayers,
        shareScreen:        state.shareScreen,
        showAnswers:        state.showAnswers,
        soundEffects:       state.soundEffects,
        swipeControls:      state.swipeControls
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:       (screen)        => { dispatch({type: Actions.CHANGE_SCREEN,     screen:         screen}) },
        setEnableCountdown: ()              => { dispatch({type: Actions.ENABLE_COUNTDOWN}) },
        setShareScreen:     ()              => { dispatch({type: Actions.SET_SHARE_SCREEN}) },
        setShowAnswers:     ()              => { dispatch({type: Actions.SET_SHOW_ANSWERS}) },
        setSoundEffects:    ()              => { dispatch({type: Actions.SET_SOUND_EFFECTS}) },
        setSwipeControls:   ()              => { dispatch({type: Actions.SET_SWIPE_CONTROLS}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenSettings);